<template>
    <div>
        <v-container grid-list-xs>
            <template>
                <v-toolbar flat color="white">
                    
                    <v-toolbar-title>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>                  
                </v-toolbar>
            </template>
        </v-container>
        
        <v-container grid-list-xs>
            <v-data-table
                class="table"
                :headers="headers"
                :items="users"
                :search="search"
                :sort-by="[{ key: 'code', order: 'code' }]"
                :rows-per-page-items="[10, 25]">
                <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.p_code }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>                
                <td class="text-xs-left">{{ props.item.expiration_date }}</td>
                <td class="text-xs-left">{{ props.item.qty }}</td>      
                <td class="text-xs-center">
                    <v-icon class="mr-2" @click="adj_item( 'Add QTY',props.item.p_code ,props.item.name ,props.item.expiration_date, props.item.qty )">add</v-icon>
                    <v-icon class="mr-2" @click="adj_item( 'Delete QTY' ,props.item.p_code ,props.item.name,props.item.expiration_date, props.item.qty )">remove</v-icon>
                    <v-icon class="mr-2" @click="adj_item( 'Waste',props.item.p_code ,props.item.name,props.item.expiration_date, props.item.qty )">delete</v-icon>                    
                </td>                               
                </template>

            </v-data-table>
            
        </v-container>


        <v-dialog v-model="dialog_c" max-width="290">
                <v-card>
                    <v-card-title class="headline">{{ title_box }}</v-card-title>
                        <v-container grid-list-xs>
                              <p>Name : {{sel_name}}</p>
                              <p>Expiration Date : {{ sel_expiration_date }}</p>  
                              <v-text-field
                                    v-model="qty_adj"
                                    type = "number"
                                    @input="validateInput"
                                    label=""
                                ></v-text-field>                                    
                                    <v-layout align-center justify-center>
                                        <v-card-actions class="text-xs-center">
                                            <v-btn class="font-weight-light" tile color="black" dark   @click="adj()"
                                            >Save</v-btn>
                                        </v-card-actions>    
                                    </v-layout>    
                        </v-container>      

                </v-card>
                </v-dialog>


    </div>
    
</template>
  
<script>
import axios from "axios"

  export default {    
        
    data() {
        return {
                /** กำหนด headers ให้ตรง */
                headers:[ 
                { text: 'Code', value: 'p_code'  },
                { text: 'Name', value: 'name' },
                { text: 'Exp. Date', value: 'expiration_date' },
                { text: 'qty', value: 'qty' },      
                { text: 'Actions', value: 'actions', align: 'center', sortable: false },                     
                ],
                table_details:[],
                users: [],
                search: '',
                dialog : false,
                dialog_c : false,
                title_box : '',
                sel_p_code : '',
                sel_name : '',
                sel_expiration_date : '',
                sel_qty : 0 ,
                qty_adj : 0,
                branch : '',
                date: new Date().toISOString().substr(0, 10),
                url : "https://ws.plantifulbkk.shop/images/" ,
            }
        },
        created () {

            this.read_data()
            this.branch = this.$store.getters.get_branch
        },

        methods :{
            read_data() {
                const vm = this;

                vm.axios.get("https://ws.plantifulbkk.shop/get_inventory_details.php",{
                params: {
                            scode: this.$store.getters.get_docno ,
                        }
                    }).then(response=>{                         
                    var result = JSON.parse(JSON.stringify(response.data))
                    vm.users = result
                    console.log(vm.users)
                });
            },

            adj_item( title ,p_code , name , expiration_date, qty ){
                
                this.title_box = title
                this.sel_p_code = p_code
                this.sel_name = name
                this.sel_expiration_date = expiration_date
                this.sel_qty = qty
                this.qty_adj = 0
                this.dialog_c = true

            },
            adj(){
                

                const vm = this;
                vm.axios.get("https://ws.plantifulbkk.shop/post_adj_inventory.php",{
                    params: {
                        scode : this.$store.getters.get_branch ,
                        title_box : this.title_box ,
                        sel_p_code : this.sel_p_code ,
                        sel_name : this.sel_name ,
                        sel_expiration_date : this.sel_expiration_date ,
                        qty_adj : this.qty_adj,
                        sel_qty : this.sel_qty ,

                    }
                }).then(result=>{
                        console.log(result.data)
                        this.read_data()
                    })
                .catch(function (error) {
                        alert("Error")
                        console.log(error)
                    })
                
                this.dialog_c = false
            },
            validateInput() {

                if (parseInt(this.qty_adj, 10) > parseInt(this.sel_qty, 10) && this.title_box !== 'Add QTY'  ){

                    console.log(' replace')                    
                    this.qty_adj = 0
                    alert('The input cannot exceed '+this.sel_qty)

                }
            },

                  

        },    
  
  }
</script>
  
<style scoped>
.v-text-field{
      width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/pages/view_inventory.vue